import { Input, Popover, CheckboxGroup, CheckboxButton } from 'element-ui';

export default {
    name: 'CharityPietaAnswer',
    props: {
        id: [Number, String],
        value: Boolean,
        false_answer_label: String,
        true_answer_label: String,
        options: Array,
        disabled: Boolean
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    computed: {
        column_class() {
            return "col-12"
        },
        label_class_value() {
            return `float-left ${this.label_class}`
        }
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.prop_value = [val ? this.true_answer_label : this.false_answer_label];
                this.handler_change();
            }
        },
        options: {
            immediate: true,
            handler(val, oldVal) {
                if (!val) {
                    this.setOptions();
                }
                this.handler_change();

            }
        }
    },
    data() {
        return {
            prop_value: false,
        };
    },
    methods: {
        handler_click(value) {
            if (this.disabled) {
                return;
            }
            if (value) {
                this.prop_value = [value];
            }
            this.handler_change();
        },
        handler_change() {
            var self = this;
            var isYes = self.prop_value[0] == self.true_answer_label;
            self.$emit("update:value", isYes);
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        setOptions() {
            var options = [];
            options.push(this.false_answer_label);
            options.push(this.true_answer_label);

            this.$emit("update:options", options);
        }
    },
    mounted() {
        if (!this.options || this.options.length) {
            this.setOptions();
            this.handler_change();
        }
        this.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/pages/charity-pieta-house/charity-pieta-house.js